import { computed } from 'vue'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { getCurrentLocale, i18n, type AppLocale } from './index'

export const elementLocales: Record<AppLocale, any> = {
  'zh-CN': zhCn,
  'en-US': en,
}

export const elementLocale = computed(() => {
  ;(i18n.global.locale as any).value
  return elementLocales[getCurrentLocale()]
})
